<div class="container mt-8">
    <div class="row mb-8">
        <div class="col-md-4">
            <div class="card text-center select-card" [ngClass]="{'selected-card': opcionSeleccionada === 'propia'}"
                (click)="seleccionarOpcion('propia')">
                <div class="card-body">
                    <i class="bi bi-person-circle icon-large mb-3"></i>
                    <h5 class="card-title">Yo gestiono esta cuenta</h5>
                    <p class="card-text">Serás el responsable de gestionar esta empresa.</p>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card text-center" [ngClass]="{'selected-card': opcionSeleccionada === 'existente'}" (click)="seleccionarOpcion('existente')">
                <div class="card-body">
                    <i class="bi bi-people icon-large mb-3"></i>
                    <h5 class="card-title">Elegir un usuario registrado</h5>
                    <p class="card-text">Selecciona un usuario ya registrado para que gestione esta empresa.</p>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card text-center select-card" [ngClass]="{'selected-card': opcionSeleccionada === 'nuevo'}"
                (click)="seleccionarOpcion('nuevo')">
                <div class="card-body">
                    <i class="bi bi-person-plus icon-large mb-3"></i>
                    <h5 class="card-title">Agregar un nuevo usuario</h5>
                    <p class="card-text">Crea un nuevo usuario con permisos para gestionar esta empresa.</p>
                </div>
            </div>
        </div>

    </div>

    <!-- <div *ngIf="opcionSeleccionada === 'existente'" class="form-group mt-4">
        <label for="usuarioExistente">Seleccionar Usuario</label>
        <select id="usuarioExistente" class="form-control" [(ngModel)]="usuarioSeleccionado">
            <option *ngFor="let usuario of usuariosRegistrados" [value]="usuario.id">
                {{ usuario.nombre }}
            </option>
        </select>
    </div> -->

    <div *ngIf="opcionSeleccionada === 'existente'" class="mt-4">
        <!-- Divider -->
        <div class="my-10 border-t"></div>

        <h5>Seleccionar Usuario Registrado</h5>
        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col" style="width: 100px;">Seleccionar</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Correo Electrónico</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let usuario of usuariosRegistrados" (click)="seleccionarUsuario(usuario.id)"
                        [ngClass]="{'selected-row': usuarioSeleccionado === usuario.id}">
                        <td>
                            <input type="radio" name="usuarioSeleccionado" [value]="usuario.id"
                                [(ngModel)]="usuarioSeleccionado" (click)="$event.stopPropagation()" />
                        </td>
                        <td>{{ usuario.nombre }}</td>
                        <td>{{ usuario.email }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-8">
            <div *ngIf="opcionSeleccionada === 'nuevo'" class="mt-4">
                <!-- Divider -->
                <div class="my-10 border-t"></div>

                <div class="card p-4">
                    <h5 class="mb-4" style="font-weight: 400;">Información del nuevo usuario</h5>
                    
                    <form *ngIf="nuevoUsuarioForm" [formGroup]="nuevoUsuarioForm">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Nombre Completo</mat-label>
                                    <input matInput id="nombreNuevoUsuario" type="text" formControlName="nombre"
                                        placeholder="Ingresa el nombre completo" />
                                    <mat-error
                                        *ngIf="nuevoUsuarioForm.get('nombre').invalid && nuevoUsuarioForm.get('nombre').touched">
                                        El nombre es requerido.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Correo Electrónico</mat-label>
                                    <input matInput id="emailNuevoUsuario" type="email" formControlName="email"
                                           placeholder="usuario@ejemplo.com" (blur)="onEmailBlur()" />
                                    <mat-error
                                        *ngIf="nuevoUsuarioForm.get('email').invalid && nuevoUsuarioForm.get('email').touched">
                                        Un correo válido es requerido.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <div *ngIf="emailValidationStarted && !emailAvailable" class="d-flex align-items-center alert-spacer">
                                    <mat-icon svgIcon="mat_outline:error_outline"></mat-icon>
                                    <div class="ml-2 text-ancho text-danger">El correo ya está registrado, prueba con otro.</div>
                                </div>
                                
                                <div *ngIf="emailValidationStarted && emailAvailable" class="d-flex align-items-center alert-spacer">
                                    <mat-icon class="text-success" svgIcon="mat_outline:check"></mat-icon>
                                    <div class="ml-2 text-ancho">Usuario disponible.</div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3 mb-8">
                            <div class="col-md-12">
                                <mat-form-field class="w-100">
                                    <mat-label>Contraseña</mat-label>
                                    <input matInput id="contrasenaNuevoUsuario" type="password"
                                           formControlName="contrasena" placeholder="********" />
                                    <mat-error *ngIf="nuevoUsuarioForm.get('contrasena').hasError('required') && nuevoUsuarioForm.get('contrasena').touched">
                                        La contraseña es requerida.
                                    </mat-error>
                                    <mat-error *ngIf="nuevoUsuarioForm.get('contrasena').hasError('invalidPassword') && nuevoUsuarioForm.get('contrasena').touched">
                                        La contraseña debe tener al menos 8 caracteres, incluir letras mayúsculas, minúsculas, números y un carácter especial.
                                    </mat-error>
                                    <mat-error *ngIf="nuevoUsuarioForm.get('contrasena').hasError('pattern') && nuevoUsuarioForm.get('contrasena').touched">
                                        La contraseña no debe contener secuencias de tres o más caracteres iguales.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        
                    </form>
                </div>
            </div>




        </div>
        <div class="col-sm-2"></div>
    </div>

    <!-- <div *ngIf="opcionSeleccionada === 'nuevo'" class="form-group mt-4">
        <label for="nombreNuevoUsuario">Nombre del nuevo usuario</label>
        <input id="nombreNuevoUsuario" class="form-control" [(ngModel)]="nuevoUsuario.nombre" placeholder="Nombre">
        
        <label for="emailNuevoUsuario" class="mt-2">Correo electrónico</label>
        <input id="emailNuevoUsuario" class="form-control" [(ngModel)]="nuevoUsuario.email" placeholder="Correo electrónico">
    </div> -->
</div>